// extracted by mini-css-extract-plugin
export var mobile = "service-template-mobile-module--mobile--19hgj";
export var image = "service-template-mobile-module--image--3tGB8";
export var orderName = "service-template-mobile-module--orderName--3vThn";